<script lang="ts" setup>
  import { onMounted, ref } from 'vue';
  import { useStepper } from '../../composables/use-stepper';
  import type { StepperComponent } from '../../store/stepper.store';
  import { LoaderContainer } from '@tundr/ds-components';

  export type StepperProps = {
    namespace: string;
    steps: StepperComponent[];
  };

  const props = defineProps<StepperProps>();
  const initialized = ref(false);

  const stepper = useStepper(props.namespace);

  onMounted(() => {
    stepper.initializeSteps(props.steps);
    initialized.value = true;
  });

  const currentComponent = stepper.currentActiveComponent;
</script>

<template>
  <div v-if="initialized">
    <component :is="{ ...currentComponent }" v-bind="$attrs" />
  </div>
  <div v-else><LoaderContainer /></div>
</template>
